// AnimeSearch.tsx
import { useEffect, useState } from 'react';
import { Grid, Typography, Stack, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDebounce } from '../../hooks/useDebounce';
import { fetchAnime, } from './animeSlice';
import { clearResults } from '../../features/anime/animeSlice';
import SearchBar from '../../components/SearchBar';
import AnimeCard from '../../components/AnimeCard';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import AnimeCardSkeleton from '../../components/AnimeCardSkeleton';

export default function AnimeSearch() {
  const [query, setQuery] = useState('');
  const dq = useDebounce(query);
  const dispatch = useAppDispatch();
  const { items, loading, error, page, hasNext } = useAppSelector((s) => s.anime);
  const nav = useNavigate();

  useEffect(() => {
    if (dq.trim()){ 
       dispatch(clearResults());
      dispatch(fetchAnime({ query: dq, page: 1 }));}
  }, [dq, dispatch]);

  return (
    <>
    <Box sx={{ m:3}}>
      <Typography variant="h3" component="h1" textAlign="center" gutterBottom sx={{ fontWeight: 'bold' }}>
        <Box component="span" sx={{ color: 'success.main' }}>Ani</Box>Search
      </Typography>
      <SearchBar value={query} onChange={setQuery} />
      {error && <Typography color="error">{error}</Typography>}
      {!loading && items.length === 0 && dq && (
        <Typography>No results for “{dq}”</Typography>
      )}
     <Grid container spacing={3} mt={1}>
  {loading
    ? [...Array(24)].map((_, i) => (
        <Grid size={{ xs: 6, sm: 4, md: 3, lg: 2 }} key={`sk-${i}`}>
          <AnimeCardSkeleton />
        </Grid>
      ))
    : items.map((a) => (
        <Grid size={{ xs: 6, sm: 4, md: 3, lg: 2 }} key={a.mal_id}>
          <div onClick={() => nav(`/anime/${a.mal_id}`)} style={{ cursor: 'pointer' }}>
            <AnimeCard anime={a} />
          </div>
        </Grid>
      ))}
</Grid>

      </Box>
      

      <Stack direction="row" justifyContent="center" spacing={2} mt={3}>
        <Button disabled={page === 1} onClick={() => dispatch(fetchAnime({ query: dq, page: page - 1 }))}>
          Prev
        </Button>
        <Typography alignSelf="center">Page {page}</Typography>
        <Button disabled={!hasNext} onClick={() => dispatch(fetchAnime({ query: dq, page: page + 1 }))}>
          Next
        </Button>
      </Stack>
    </>
  );
}


